import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';
import SettingMer from '@/utils/settingMer';
var service = axios.create({
  baseURL: SettingMer.apiBaseURL,
  timeout: 60000 // 过期时间
});
var reloginRedirecting = false;
function handleUnauthorized() {
  if (reloginRedirecting) return;
  reloginRedirecting = true;
  Message.error('无效的会话，或者登录已过期，请重新登录。');
  store.dispatch('user/resetToken').finally(function () {
    if (window.location.pathname !== '/login') {
      window.location.replace("/login?redirect=".concat(encodeURIComponent(window.location.pathname + window.location.search)));
    } else {
      reloginRedirecting = false;
    }
  });
}

// request interceptor
service.interceptors.request.use(function (config) {
  // 发送请求之前做的
  var token = !store.getters.token ? sessionStorage.getItem('token') : store.getters.token;
  if (token) {
    config.headers['Authori-zation'] = token;
  }
  if (/get/i.test(config.method)) {
    config.params = config.params || {};
    config.params.temp = Date.parse(new Date()) / 1000;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

/**
 * 审批流结果提示。
 * STARTED        - 已进入审批流，商品要等审批通过才会上架
 * FAILED         - 审批服务没连上/发起失败，业务已被卡在待审核，必须让商户知道
 * NOT_CONFIGURED - 没配审批场景，走平台常规审核，不打扰商户
 */
function notifyApprovalResult(headers) {
  if (!headers) return;
  var status = headers['x-approval-status'];
  if (!status || status === 'NOT_CONFIGURED') return;
  var msg = headers['x-approval-message'] || '';
  try {
    msg = decodeURIComponent(msg);
  } catch (e) {
    // 后端编码异常时按原文展示
  }
  if (status === 'STARTED') {
    Message({
      message: msg || '已提交审批，审批通过后生效',
      type: 'success',
      duration: 4 * 1000
    });
  } else if (status === 'FAILED') {
    Message({
      message: msg || '审批流程发起失败，请联系平台处理',
      type: 'error',
      duration: 8 * 1000
    });
  }
}

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  // 如果是文件下载请求（blob类型），直接返回响应数据
  if (response.config.responseType === 'blob') {
    return res;
  }

  // if custom code is not 20000, it is judged as an error.
  if (res.code === 401) {
    handleUnauthorized();
    return Promise.reject(new Error(res.message || 'Unauthorized'));
  } else if (res.code === 403) {
    Message.error(res.message || '没有权限访问。');
    return Promise.reject(new Error(res.message || 'Forbidden'));
  }
  if (res.code !== 200 && res.code !== 401) {
    Message({
      message: res.message || 'Error',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject();
  } else {
    // 审批流提示：后端通过 X-Approval-* 头告知本次操作是否进了审批流。
    // 拦截器只把 res.data 抛给业务代码，header 会被丢掉，所以在这里统一提示。
    notifyApprovalResult(response.headers);
    return res.data;
  }
}, function (error) {
  var status = error.response && error.response.status;
  if (status === 401) {
    handleUnauthorized();
  } else if (status === 403) {
    Message.error('没有权限访问。');
  } else {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
  }
  return Promise.reject(error);
});
export default service;